import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-placeholder',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.css',
})
export class PlaceholderComponent {
  openSwaggerDocs() {
    const apiBaseUrl = environment.apiBaseUrl;

    window.open(`${apiBaseUrl}/documentation`, '_blank');
  }

  // TODO : make this show up in local modes only
  /*
  openDatabase() {
    const apiBaseUrl = environment.apiBaseUrl;

    window.open(`http://localhost:5555`, '_blank');
  }
    */
}
